<template>
  <div class="schoolAdmin">
    <v-row>
      <v-col>
        <v-row>


        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>

  export default {

    components: {

    },

    data(){
      return{
      }
    }
  };
</script>
